module.exports = __webpack_public_path__ + "media/5.67badbc3.mp3";